
import Vue from 'vue'
import CompanyList from './CompanyList.vue';
import PositionList from '@/components/company/PositionList.vue'

export default Vue.extend({
  name: 'CompanyTabs',
  components: {
    CompanyList,
    PositionList
  },
  props: {
    tab: {
      type: Number,
      required: false,
      default: 0,
    }
  },
  data() {
    return {
      currentTab: 0,
    }
  },
  computed: {
    title() {
      switch (this.currentTab as number) {
        case 0:
          return this.$vuetify.lang.t('$vuetify.company_list')
        case 1:
          return this.$vuetify.lang.t('$vuetify.company_list_deleted')
        case 2:
          return this.$vuetify.lang.t('$vuetify.positions')
        case 3:
          return this.$vuetify.lang.t('$vuetify.positions_deleted')
        default:
          return ''
      }
    }
  },
  watch: {
    currentTab(newTab: number) {
      this.$nextTick(() => {
        const refs = ['companyListActive', 'companyListDeleted', 'positionListActive', 'positionListDeleted'];
        const ref = this.$refs[refs[newTab]];
        if (ref) {
          ((ref as any).$refs.list as any)?.getData();
        }
      });
    }
  }
})
